export default __webpack_public_path__ + "static/media/H0001.a5176350.png";